import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  isLoading$ = new Subject<boolean>();

  numLoading: number;

  constructor() {
    this.numLoading = 0;
  }

  show(): void{
    this.numLoading++;
    this.isLoading$.next(true);
  }
  hide(): void{
    this.numLoading--;
    if(this.numLoading<=0){
      this.isLoading$.next(false);
    }
  }

}
